var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-facecade',{key:1,ref:"doc_list",attrs:{"url":_vm.url,"tableHeight":_vm.tableHeight,"columns":_vm.columnList,"buttons":[],"addButton":{ enabled: false, emit: 'addDocument', permission: 'default' },"deleteButton":{ enabled: false, permission: 'default' },"updateButton":{ enabled: false, permission: 'default' }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba26648","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/Document/Index2.vue
// module id = null
// module chunks = 